import { z } from 'zod';

export const customerSchema = z.object({
  name: z.string().min(1, 'Name is required').max(50, 'Name must be at most 50 characters'),
  code: z.string().max(3, 'Code must be at most 3 characters').optional(),
  email: z
    .string()
    .max(30, 'Email must be at most 30 characters')
    .email('Invalid email address'),
  phone: z
    .string()
    .optional()
    .refine((value) => !value || /^[^A-Za-z]*$/.test(value), 'Phone must not contain letters'),
  billingAddress: z
    .string()
    .min(1, 'Billing address is required')
    .max(255, 'Billing address must be at most 255 characters'),
  shippingAddress: z.string().max(255, 'Shipping address must be at most 255 characters').optional(),
  messageOnInvoice: z.string().optional(),
  internalNotes: z.string().optional(),
});

export type CustomerFormData = z.infer<typeof customerSchema>;

export interface Customer extends CustomerFormData {
  id: string;
  code?: string;
  createdAt: string;
  updatedAt: string;
}
